import CheckOut from "../components/inventory/buy/checkout";
import Nav from "../components/inventory/vendor/navbar";
const ListingPage = () => {
  return (
    <div>
      <Nav />
      <CheckOut />
    </div>
  );
};

export default ListingPage;